module.exports = __webpack_public_path__ + "static/images/2288819b5b461d61bed9c098694219bf.svg";